import * as Types from "actions/types";

const initialState = {
  isAuthenticating: false,
  user: {},

  loggedIn: false,

  signUpError: false,
  signInError: false,

  showSignUpConfirmationModal: false,
  showSignInConfirmationModal: false,

  confirmSignUpError: false,
  confirmLoginError: false,

  signInErrorMessage: '',
  signUpErrorMessage: '',

  confirmLoginErrorMessage: '',
  confirmSignUpErrorMessage: ''
}

export default (state = initialState, action) => {
  switch(action.type) {
    case Types.SHOW_SIGN_IN_CONFIRMATION_MODAL:
      return {
        ...state,
        isAuthenticating: false,
        showSignInConfirmationModal: true
      }
    case Types.SHOW_SIGN_UP_CONFIRMATION_MODAL:
      return {
        ...state,
        isAuthenticating: false,
        showSignUpConfirmationModal: true
      }
    case Types.CONFIRM_SIGNUP:
      return {
        ...state,
        isAuthenticating: true
      }
    case Types.CONFIRM_SIGNUP_SUCCESS:
      return {
        ...state,
        isAuthenticating: false,
        showSignUpConfirmationModal: false
      }
    case Types.CONFIRM_SIGNUP_FAILURE:
      return {
        ...state,
        isAuthenticating: false,
        confirmSignUpError: false,
        confirmSignupErrorMessage: action.error.message
      }
    case Types.SIGN_UP:
      return {
        ...state,
        isAuthenticating: true,
      }
    case Types.SIGN_UP_SUCCESS:
      return {
        ...state,
        isAuthenticating: false
      }
    case Types.SIGN_UP_FAILURE:
      return {
        ...state,
        isAuthenticating: false,
        signUpError: true,
        signUpErrorMessage: action.error.message
      }
    case Types.LOG_IN:
      return {
        ...state,
        isAuthenticating: true,
        signInError: false,
      }
    case Types.LOG_IN_SUCCESS:
      return {
        isAuthenticating: false,
        user: action.user,
        showSignInConfirmationModal: true,
        loggedIn: true,
      }
    case Types.LOG_IN_FAILURE:
      return {
        ...state,
        isAuthenticating: false,
        signInError: true,
        signInErrorMessage: action.error.message
      }
    case Types.RETRIEVE_SESSION: {
      return {
        ...state,
        isAuthenticating: true,
      }
    }
    case Types.RETRIEVE_SESSION_SUCCESS: {
      return {
        isAuthenticating: false,
        user: action.user,
        loggedIn: true,
      }
    }
    case Types.RETRIEVE_SESSION_FAILURE: {
      return {
        ...state,
        isAuthenticating: false
      }
    }
    case Types.CONFIRM_LOGIN: {
      return {
        ...state,
        isAuthenticating: true
      }
    }
    case Types.CONFIRM_LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticating: false,
        showSignInConfirmationModal: false
      }
    case Types.CONFIRM_LOGIN_FAILURE: {
      return {
        ...state,
        isAuthenticating: false
      }
    }
    case Types.LOG_OUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js